import { useEffect, useState } from "react";
import { api, formatApiError } from "@/lib/apiClient";
import { toast } from "sonner";
import { CalendarCheck, MapPin, Check, X, HelpCircle, CalendarPlus } from "lucide-react";

const OPTIONS = [
  { v: "yes", label: "Confirmo", icon: Check, color: "#22C55E" },
  { v: "maybe", label: "Talvez", icon: HelpCircle, color: "#EAB308" },
  { v: "no", label: "Não posso", icon: X, color: "#737373" },
];

/* Aviso da convocatória para o próprio consultor: confirma e mete na agenda. */
export default function ConvocationNotice() {
  const [conv, setConv] = useState(null);
  const [saving, setSaving] = useState(false);

  useEffect(() => {
    api.get("/convocations/mine/next").then((r) => setConv(r.data.convocation)).catch(() => {});
  }, []);

  if (!conv) return null;

  const answer = async (v) => {
    setSaving(true);
    try {
      await api.post(`/convocations/${conv.id}/respond`, { answer: v });
      setConv({ ...conv, my_answer: v });
      toast.success(v === "no" ? "Registado. Obrigado por avisar." : "Presença registada!");
    } catch (err) { toast.error(formatApiError(err)); }
    setSaving(false);
  };

  return (
    <div className="kw-card p-5 border-l-2 border-[#E50000]" data-testid="convocation-notice">
      <div className="flex flex-wrap items-start gap-4">
        <CalendarCheck className="w-5 h-5 text-[#E50000] mt-1 shrink-0" />
        <div className="flex-1 min-w-[260px]">
          <div className="kw-overline text-[#E50000]">Convocatória · {conv.my_club}</div>
          <div className="font-display text-xl font-black uppercase tracking-tight">{conv.title}</div>
          <div className="text-sm text-[#A3A3A3] mt-1">{conv.when_label}</div>
          <div className="text-xs text-[#737373] mt-0.5 flex items-center gap-1">
            <MapPin className="w-3 h-3" /> {conv.location}
          </div>
          {conv.notes && <p className="text-xs text-[#A3A3A3] mt-2 max-w-2xl">{conv.notes}</p>}
        </div>
        <div className="flex flex-col gap-2 shrink-0">
          <div className="flex gap-2">
            {OPTIONS.map((o) => {
              const active = conv.my_answer === o.v;
              return (
                <button key={o.v} onClick={() => answer(o.v)} disabled={saving}
                  className="text-[10px] uppercase tracking-widest font-bold px-3 py-2 border inline-flex items-center gap-1.5 transition-colors"
                  style={active ? { background: o.color, borderColor: o.color, color: "#0A0A0A" }
                    : { borderColor: "#333", color: o.color }}
                  data-testid={`convocation-answer-${o.v}`}>
                  <o.icon className="w-3 h-3" /> {o.label}
                </button>
              );
            })}
          </div>
          {conv.my_answer !== "no" && (
            <div className="flex gap-2">
              <a href={conv.google_link} target="_blank" rel="noopener noreferrer"
                className="text-[10px] uppercase tracking-widest font-bold px-3 py-2 border border-[#333] text-[#A3A3A3] hover:text-white inline-flex items-center gap-1.5"
                data-testid="convocation-google">
                <CalendarPlus className="w-3 h-3" /> Google
              </a>
              <a href={conv.ics_link}
                className="text-[10px] uppercase tracking-widest font-bold px-3 py-2 border border-[#333] text-[#A3A3A3] hover:text-white inline-flex items-center gap-1.5"
                data-testid="convocation-ics">
                <CalendarPlus className="w-3 h-3" /> Apple / Outlook
              </a>
            </div>
          )}
        </div>
      </div>
    </div>
  );
}
